import { ApiClient } from '@dozuki/web-js/utils';
import { QueryClient, UseQueryResult } from '@tanstack/react-query';
import { getTranslations, TranslationsResponse } from '~/monolith-api';
import { useRegisteredQuery } from '~/queries';

// Expose the key for translations query data so that it can be mocked during
// testing
export const TRANSLATIONS_KEY = 'translations';

export function useTranslations(): UseQueryResult<TranslationsResponse> {
   return useRegisteredQuery(
      [TRANSLATIONS_KEY],
      async (): Promise<TranslationsResponse> => {
         return await getTranslations();
      },
      {
         // 30 minutes
         staleTime: 1800000,
         // We always want this data available so that translations never have a loading state
         cacheTime: Infinity,
      }
   );
}

export async function prefetchTranslations(
   apiClient: ApiClient,
   queryClient: QueryClient
): Promise<void> {
   await queryClient.fetchQuery([TRANSLATIONS_KEY], () => getTranslations({ apiClient }));
}
